import { get, post, put, del } from '@api/request';

const namespace = 'litigation';

export async function fetchProperties(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/properties`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertArbitrationProperty(
  { litigationService },
  authenticationToken,
  { arbitrationID, payload },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/properties`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteArbitrationProperty(
  { litigationService },
  authenticationToken,
  { arbitrationPropertyID },
) {
  const url = `${litigationService}/${namespace}/arbitrationproperty/${arbitrationPropertyID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateArbitrationProperty(
  { litigationService },
  authenticationToken,
  { arbitrationPropertyID, payload },
) {
  const url = `${litigationService}/${namespace}/arbitrationproperty/${arbitrationPropertyID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function updateArbitrationPropertyFinalValue(
  { litigationService },
  authenticationToken,
  { arbitrationPropertyID, payload },
) {
  const url = `${litigationService}/${namespace}/arbitrationproperty/${arbitrationPropertyID}/finalvalue`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function distributeArbitrationProrata(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/distributeprorata`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function setArbitrationPropertyFiledTimely(
  { litigationService },
  authenticationToken,
  { arbitrationPropertyID, payload },
) {
  const url = `${litigationService}/${namespace}/arbitrationproperty/${arbitrationPropertyID}/filedtimely`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function setArbitrationPropertyTaxesPaid(
  { litigationService },
  authenticationToken,
  { arbitrationPropertyID, payload },
) {
  const url = `${litigationService}/${namespace}/arbitrationproperty/${arbitrationPropertyID}/taxespaid`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}